<template>
    <div v-for="article in articles" :key="article.id" :class="`${bsColumnClassMd} ${bsColumnClassLg}`" class="col-sm-12">
        <LayoutArticleCardsArticleCard :article="article" :image-on-left="imageOnLeft" class="mb-4" />
    </div>
    <slot />
</template>

<script lang="ts">
import type { PropType } from 'vue'
import type Article from '~/models/StaticContent/Article/Article'

export default {
    props: {
        articles: {
            type: Array as PropType<Article[]>,
            required: true,
        },
        colsLg: {
            type: Number,
            default: 3,
            required: false,
        },
        colsMd: {
            type: Number,
            default: 2,
            required: false,
        },
        imageOnLeft: {
            type: Boolean,
            default: false,
            required: false,
        },
    },
    computed: {
        bsColumnClassLg() {
            return 'col-lg-' + 12 / this.colsLg
        },
        bsColumnClassMd() {
            return 'col-md-' + 12 / this.colsMd
        },
    },
}
</script>
